<template>
	<div
		:class="[
			$style['app-notched-outline'],
			{
				[$style['app-notched-outline--visible']]: isFocused,
				[$style['app-notched-outline--notched']]: isFloated
			}
		]"
	/>
</template>

<script>
export default {
	name: 'NotchedOutline',
	props: {
		isFloated: {
			type: [Boolean, String],
			required: true
		},
		isFocused: {
			type: [Boolean, String],
			required: true
		}
	}
}
</script>

<style lang="scss" module>
@property --notch-width {
    syntax: '<length>';
    inherits: true;
    /* stylelint-disable-next-line length-zero-no-unit */
    initial-value: 0px;
}

@property --notch-close {
    syntax: '<length>';
    inherits: true;
    /* stylelint-disable-next-line length-zero-no-unit */
    initial-value: 0px;
}

.app-notched-outline {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1),
                border-color 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
    border: 2px solid getColor(stroke);
    border-radius: 4px;
    pointer-events: none;
    clip-path: polygon(
        0% 0%,
        calc(12px + var(--notch-close, 0px)) 0%,
        calc(12px + var(--notch-close, 0px)) 3px,
        calc(12px + var(--notch-width, 0px) - var(--notch-close, 0px)) 3px,
        calc(12px + var(--notch-width, 0px) - var(--notch-close, 0px)) 0%,
        100% 0%,
        100% 100%,
        0% 100%
    );

    &:not(&--notched) {
        /* stylelint-disable-next-line declaration-empty-line-before, length-zero-no-unit */
        --notch-close: calc(var(--notch-width, 0px) / 2);

        transition: opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1),
                    border-color 0.15s cubic-bezier(0.4, 0, 0.2, 1),
                    --notch-close 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &--visible {
        opacity: 1;
    }
}
</style>
